import { createContext } from 'react';
import { bluestar } from '@tanium/theme-data';
import { ThemeContextType } from './types';

export const ThemeContext = createContext<ThemeContextType>({ theme: bluestar });
